import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../EditableSentence'
import Select from '../../../../../packages/kiti/components/form/Select'

const getOptions = condition => {
  const field = condition?.field || ''
  if (field.endsWith('_id'))
    return [
      { name: 'igual a', id: 'eq' },
      { name: 'um dos', id: 'in' },
      { name: 'diferente de', id: 'neq' }
    ]

  if (field.endsWith('_ids'))
    return [
      { name: 'um dos', id: 'any' },
      { name: 'todos', id: 'all' }
    ]
  return false
}

const OperatorSentence = ({ condition, index }) => {
  const { t } = useTranslation()
  const { handleChangeIn } = useFormState()

  const options = getOptions(condition)
  if (!options) return false

  return (
    <EditableSentence
      label={t('conditions.operators.' + (condition.operator || 'eq')).toLowerCase()}
      path={['conditions', index, 'operator']}
      onChange={value => {
        handleChangeIn(['conditions', index, 'value'], undefined)
        handleChangeIn(['conditions', index, 'operator'], value?.id)
      }}
      Input={Select}
      options={options}
    />
  )
}

export default OperatorSentence
